import PropTypes from 'prop-types'
import React from 'react'
import { Map } from 'immutable'
import _partial from 'lodash/partial'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { historyRedirect } from '../../services/navigation/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'

function onClick (props) {
  const {
    history,
    auth,
    user = Map(),
    app,
    videoUrl,
  } = props
  const isInitialRender = app.get('isInitialRender')
  const language = user.getIn(['data', 'language'])

  // We came directly to the player page, so go to the detail page.
  if (isInitialRender && videoUrl) {
    historyRedirect({
      history, url: videoUrl, auth, language,
    })
  } else {
    history.goBack()
  }
}

function getClassName (props) {
  const { className, visible } = props
  return ['video-player-back']
    .concat(className || [])
    .concat(visible ? 'video-player-back--visible' : [])
    .join(' ')
}

function VideoPlayerBack (props) {
  const { staticText } = props

  return (
    <div className={getClassName(props)} onClick={_partial(onClick, props)}>
      <IconV2 type={ICON_TYPES.CHEVRON_LEFT} className="video-player-back__icon" />
      {staticText.getIn(['data', 'back'])}
    </div>
  )
}

VideoPlayerBack.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  visible: PropTypes.bool,
  className: PropTypes.array,
  user: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  app: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

const connectedVideoPlayerBack = connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'videoPlayerBack']),
  user: state.user,
  auth: state.auth,
  app: state.app,
}))(VideoPlayerBack)

export default connectedVideoPlayerBack
